import { useContext } from 'react';

import { AddItemSetQuestionConditionsContext } from './add-item-set-question-conditions-provider';

export function useAddItemSetQuestionConditions() {
  const context = useContext(AddItemSetQuestionConditionsContext);

  if (!context) {
    throw new Error(
      'useAddItemSetQuestionConditions must be used within an AddItemSetQuestionConditionsProvider',
    );
  }

  return context;
}
